import {
  hmplusVersionListConstants,
  hmplusVersionUploadConstants,
  hmplusVersionDeleteConstants,
  hmplusVersionConstants,
} from "../_redux-constants";
import { hmplusVersionListService } from "../../_services";

function getHMplusVersionList(queryParams) {
  function getHMplusVersionListLoad() {
    return { type: hmplusVersionListConstants.HMPLUSVERSION_LIST_LOADING };
  }
  function hmplusVersionListSuccess(data) {
    return {
      type: hmplusVersionListConstants.HMPLUSVERSION_LIST_SUCCESS,
      data,
    };
  }
  function hmplusVersionListFailure(error) {
    return {
      type: hmplusVersionListConstants.HMPLUSVERSION_LIST_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getHMplusVersionListLoad());
    return hmplusVersionListService.getHMplusVersionList(queryParams).then(
      (data) => {
        dispatch(hmplusVersionListSuccess(data));
      },
      (error) => {
        dispatch(hmplusVersionListFailure(error?.toString()));
      }
    );
  };
}
function uploadHMplusVersion(queryParams) {
  function hmplusVersionUploadLoad() {
    return { type: hmplusVersionUploadConstants.HMPLUSVERSION_UPLOAD_LOADING };
  }
  function hmplusVersionUploadSuccess(data) {
    return {
      type: hmplusVersionUploadConstants.HMPLUSVERSION_UPLOAD_SUCCESS,
      data,
    };
  }
  function hmplusVersionUploadFailure(error) {
    return {
      type: hmplusVersionUploadConstants.HMPLUSVERSION_UPLOAD_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(hmplusVersionUploadLoad());
    return new Promise((resolve, reject) => {
      hmplusVersionListService.uploadHMplusVersion(queryParams).then(
        (data) => {
          dispatch(hmplusVersionUploadSuccess(data));
          resolve(data);
        },
        (error) => {
          dispatch(hmplusVersionUploadFailure(error));
          reject(error);
        }
      );
    });
  };
}
function deleteHMplusVersion(queryParams) {
  function hmplusVersionDeleteLoad() {
    return { type: hmplusVersionDeleteConstants.HMPLUSVERSION_DELETE_LOADING };
  }
  function hmplusVersionDeleteSuccess(data) {
    return {
      type: hmplusVersionDeleteConstants.HMPLUSVERSION_DELETE_SUCCESS,
      data,
    };
  }
  function hmplusVersionDeleteFailure(error) {
    return {
      type: hmplusVersionDeleteConstants.HMPLUSVERSION_DELETE_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(hmplusVersionDeleteLoad());
    return hmplusVersionListService.deleteHMplusVersion(queryParams).then(
      (data) => {
        dispatch(hmplusVersionDeleteSuccess(data));
      },
      (error) => {
        dispatch(hmplusVersionDeleteFailure(error?.toString()));
      }
    );
  };
}
function hmplusVersion(queryParams) {
  function hmplusVersionLoad() {
    return { type: hmplusVersionConstants.HMPLUSVERSION_LOADING };
  }
  function hmplusVersionSuccess(data) {
    return { type: hmplusVersionConstants.HMPLUSVERSION_SUCCESS, data };
  }
  function hmplusVersionFailure(error) {
    return { type: hmplusVersionConstants.HMPLUSVERSION_FAILURE, error };
  }
  return (dispatch) => {
    dispatch(hmplusVersionLoad());
    return hmplusVersionListService.showhmplusVersion(queryParams).then(
      (data) => {
        dispatch(hmplusVersionSuccess(data));
      },
      (error) => {
        dispatch(hmplusVersionFailure(error?.toString()));
      }
    );
  };
}

export const hmplusVersionListActions = {
  getHMplusVersionList,
  uploadHMplusVersion,
  deleteHMplusVersion,
  hmplusVersion,
};
